/* eslint-disable react/jsx-props-no-spreading */
import { TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

interface AddressComponentProps {
    farmAddress: string | undefined;
    setFarmAddress: Function;
}

export function AddressComponent({
    farmAddress,
    setFarmAddress
}: AddressComponentProps): JSX.Element {
    const { t } = useTranslation();
    const [address, setAddress] = useState('');

    const handleSelect = async (value: string): Promise<void> => {
        const results = await geocodeByAddress(value);
        const latLng = await getLatLng(results[0]);
        setAddress(value);
        setFarmAddress(value, latLng);
    };

    useEffect(() => {
        if (farmAddress) {
            setAddress(farmAddress);
        }
    }, [farmAddress]);

    return (
        <div className="research-bar-component">
            <PlacesAutocomplete value={address} onChange={setAddress} onSelect={handleSelect}>
                {({ getInputProps, suggestions, getSuggestionItemProps, loading }): JSX.Element => (
                    <div>
                        <div>
                            <TextField
                                {...getInputProps({ placeholder: t('basketRecoveryAddress') })}
                                placeholder={t('basketRecoveryAddress')}
                                style={{
                                    width: '100%',
                                    border: 'none',
                                    outline: 'none',
                                    color: '#666666',
                                    fontSize: '14px',
                                    marginTop: '10px'
                                }}
                                variant="outlined"
                                InputLabelProps={{
                                    style: { color: '#D9D9D9' }
                                }}
                            />
                        </div>
                        <div
                            style={{
                                marginTop: '10px',
                                position: 'relative',
                                zIndex: 2,
                                boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.15)',
                                backgroundColor: '#fff'
                            }}>
                            {loading ? <div>{t('loading')}</div> : null}

                            {suggestions.map((suggestion) => {
                                const style = {
                                    backgroundColor: suggestion.active ? '#D9D9D9' : '#fff',
                                    padding: '2px 8px',
                                    color: '#00000099'
                                };

                                return (
                                    <div
                                        {...getSuggestionItemProps(suggestion, { style })}
                                        key={suggestion.id}>
                                        {suggestion.description}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </PlacesAutocomplete>
        </div>
    );
}
